import React, { memo } from 'react';

function NoData() {
  return <div className="no-data">No Data</div>;
}

export default memo(NoData);
